import { message, Modal } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PurchaseModalRender from './children/PurchaseModalRender';
import purchaseList from '@/constants/purchase';
import { accountList } from '@/constants/url';
import actions from '@/redux/action';
import { requsetGetPurchase, requsetGetSubscription } from '@/api/apis';
import {
  GAPurchaseModalVisibleBySizeLimit,
  GAPurchaseModalVisibleByTimesLimit,
  GAPurchaseModalVisibleByImageCutoutTimesLimit,
} from '@/ga/purchase';
import i18n from '@/i18n';
import Utils from '../../../utils';
import PayModal from '@/components/allCommon/payBill/index.jsx';
import LoginComponent from '../../allCommon/login';
import V1cart from '@/utils/V1cart';
import sendGaEvent from '@/ga';

class PurchaseModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currPackageKey: 'monthly',
      packageMap: purchaseList,
      signUpUrl: accountList.get('login'),
      enterCodeInputVisible: false,
      visible: false,
      purchaseLoading: false,
      currPackage: '',
    };
    this.timer = null;
  }

  componentDidUpdate() {
    //埋点
    window.sessionStorage.reason = '0';
    console.log(
      'uploadSizeBiggerThanLimit or imageCutoutTimesMoreThanLimit?',
      'font-size:20px;',
      this.props.purchaseModalObj.type
    );
    if (this.props.purchaseModalObj.type === 'uploadSizeBiggerThanLimit') {
      GAPurchaseModalVisibleBySizeLimit();
      window.sessionStorage.reason = '1';
    } else if (
      this.props.purchaseModalObj.type === 'imageCutoutTimesMoreThanLimit' ||
      this.props.purchaseModalObj.type === 'videoEditorTimesMoreThanLimit'
    ) {
      GAPurchaseModalVisibleByImageCutoutTimesLimit();
      window.sessionStorage.reason = '2';
    } else {
      GAPurchaseModalVisibleByTimesLimit();
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  /**
   * 轮询订阅信息
   */
  handleListenerSubscription = () => {
    this.timer = setInterval(() => {
      requsetGetSubscription()
        .then((res) => {
          if (res.code === 200) {
            console.log(this.props);
            this.props.onSubscriptionChange(res.data.subscription);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }, 12000);
  };

  /**
   * 请求购买链接
   */
  getPurchase = () => {
    console.log('请求购买链接');
    let action = Utils.getGaAction(this.props.work);

    if (action) {
      sendGaEvent({
        category: 'BuyClick',
        action: action,
        label: 'Null',
      });
    }

    this.setState({
      purchaseLoading: true,
    });
    const { currPackageKey } = this.state;
    let site = Utils.getLanguage();
    site = site === 'tk' ? 'tr' : site === 'inn' ? 'in' : site;
    let plan = currPackageKey === 'monthly' ? 'month' : 'year';

    const formData = new FormData();
    formData.append('plan', plan);
    formData.append('site', site);
    requsetGetPurchase({
      body: formData,
    })
      .then((res) => {
        console.log(res);
        if (res.code === 200) {
          let action = Utils.getGaBuyNow(this.props.work);
          if (action) {
            sendGaEvent({
              category: 'BuyNow',
              action: action,
              label: 'Null',
            });
          } else {
            this.handleListenerSubscription();
          }
          //购物车地址
          let cartUrl = res.data.cart_url;
          cartUrl = V1cart(cartUrl);
          // return

          setTimeout(() => {
            window.open(cartUrl, '_blank');
          }, 300);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({
          purchaseLoading: false,
        });
      });
  };

  handleSentCode = (e) => {
    e.stopPropagation();
    message.warn(i18n.t('purchase:promoCodeInvalidTips'));
  };

  render() {
    const { purchaseModalObj, authorization } = this.props;
    return (
      <>
        <PayModal
          purchaseModalObj={this.props.purchaseModalObj}
          subscription={this.props.subscription}
          currPackageKey={this.state.currPackageKey}
        ></PayModal>

        <PurchaseModalRender
          currPackageKey={this.state.currPackageKey}
          enterCodeInputVisible={this.state.enterCodeInputVisible}
          currPackage={
            this.state.currPackage
              ? this.state.currPackage
              : this.state.packageMap.get(this.state.currPackageKey)
          }
          signUpUrl={this.state.signUpUrl}
          purchaseType={!this.props.profileObj ? 'account' : 'cartUrl'}
          getPurchase={this.getPurchase}
          purchaseLoading={this.state.purchaseLoading}
          purchaseModalObj={purchaseModalObj}
          authorization={authorization}
          handleSentCode={this.handleSentCode}
        />
        <LoginComponent />
      </>
    );
  }
}

const mapStateToPropos = (state) => ({
  purchaseModalObj: state.common.purchaseModalObj,
  profileObj: state.common.profileObj,
  subscription: state.common.subscription,
  authorization: state.common.authorization,
  work: state.work.work,
});
const mapDispatchToProps = (dispatch) => ({
  onPurchaseModalObjChange: (purchaseModalObj) =>
    dispatch(actions.onPurchaseModalObjChange(purchaseModalObj)),
  onSubscriptionChange: (subscription) =>
    dispatch(actions.onSubscriptionChange(subscription)),
  onSaveSwitchOther: (subscription) =>
    dispatch(actions.onSaveSwitchOther(subscription)),
});

export default connect(mapStateToPropos, mapDispatchToProps)(PurchaseModal);
